import { specicalCssValuePattern, STYLE_FIELDS } from "../../../../../lib/comps/PropPanel/StylePanel/utils/constant";
import { pickBy } from "lodash-es";
export function getStyleAfterUnitCompletion(styleObj) {
  const newObj = {};
  // 如果是在列表中，表明该字段是需要带单位的，提交之前检查是否非零，并加上单位
  STYLE_FIELDS.forEach(field => {
    let value = styleObj[field];
    // eslint-disable-next-line eqeqeq
    if (value == null) {
      newObj[field] = undefined;
      return;
    }
    let haveImportant = false;
    const IMPORTANT_STR = ' !important';
    if (typeof value === 'string' && value.includes(IMPORTANT_STR)) {
      haveImportant = true;
      value = value.replace(IMPORTANT_STR, '');
    }
    if (value && !specicalCssValuePattern.test(value)) {
      // 如果是一些无法解析为数字的非法字符，直接置为原始的值
      const parsedValue = parseFloat(value);
      newObj[field] = isNaN(parsedValue) ? String(value) : `${parsedValue}px`;
    }
    if (haveImportant && newObj[field]) {
      newObj[field] += IMPORTANT_STR;
    }
  });
  return pickBy(newObj, v => v !== undefined && v !== '');
}
//# sourceMappingURL=styleUtils.js.map
